/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PaymentProviderKind = {
    Stripe: 'Stripe',
    CardTerminal: 'CardTerminal',
    Im30: 'Im30',
    CoinAcceptor: 'CoinAcceptor',
    Wallet: 'Wallet'
} as const;
export type PaymentProviderKind = typeof PaymentProviderKind[keyof typeof PaymentProviderKind];

